import React from 'react';
import {ScenarioActionProps} from '../../actionMenuTypes';
import {useLocation} from 'react-router-dom';
import {getUrlRoute, MRAppRoutes} from '../../../router/routes';
import {useScenarioDetail} from '../../../../store/scenario';
import {useLastValidValue} from '../../../../hooks/useLastValidValue';
import SideBarLinkItem from '../../../layout/common/SideBarLinkItem';
import {useModelInput} from '../../../../store/modelInputs';
import {ModelInputType} from 'hemwb-api';
import {tid} from '../../../../testUtils';
import {SUBMODEL_ACTION_MENU_IDS} from '../../../../test/types';
import {View16} from '@carbon/icons-react';

const ScenarioParametersViewActionMenuLink: React.FC<Partial<ScenarioActionProps>> = (props) => {
  const location = useLocation();
  const _scenario = useScenarioDetail(Number(props.scenario ? props.scenario.id : null));
  const scenario = useLastValidValue(_scenario);
  const input = useModelInput(scenario?.executionSetupId);

  const link =
    props.model && props.scenario
      ? getUrlRoute(MRAppRoutes.SCENARIO_PARAMETERS_VIEW, {
          modelUuid: props.model.uuid,
          scenarioId: props.scenario.id,
        })
      : '#';

  return (
    <SideBarLinkItem
      {...tid(SUBMODEL_ACTION_MENU_IDS.SCENARIO_VIEW)}
      selected={location.pathname === link}
      disabled={!props.model || !props.scenario || (input && input.type === ModelInputType.JSON)}
      linkTo={link}
      icon={<View16 />}
      text="View Parameters"
    />
  );
};

export default ScenarioParametersViewActionMenuLink;
